/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: mediaplayer.js
 */
(function($, w) {
	// We aren't using strict mode because of arguments.callee 
	// in external script load for YouTube player
	//'use strict'
	
	/*
	 * Put a flag and declare our space on portal
	 */
	$.namespace('SCS.mediaplayer');
	
	// Flag for classes
	SCS.mediaplayer.MASTER_CLASS = 'scs-media-player-';
	SCS.mediaplayer.CONTROL_CLASS = '.' + SCS.mediaplayer.MASTER_CLASS + 'control-';
	SCS.mediaplayer.MUTE_CLASS = SCS.mediaplayer.MASTER_CLASS + 'control-volume-mute';
	SCS.mediaplayer.IMAGES = '/etc/designs/portal/resources/mediaplayer/';
	
	
	/**
	 * Check if we are in IOS devices
	 * We need to check this because IOS doesn't allow mechanical click
	 * 
	 * @return $platform {integer} 1 for IOS devices or 0 for not
	 */
	SCS.mediaplayer.isIOS = function() {
		var $platform = navigator.platform.match(/(iPad|iPhone|iPod)/);
		return $platform && $platform != 'null' ? 1 : 0;
	};
	
	
	/**
	 * Helper function for play overlay on IOS devices
	 * 
	 * @param element {object} Player element
	 * 
	 * @return $play_button_element {object} Overlay play button element
	 */
	SCS.mediaplayer.playOverlay = function(element) {
		var $play_button_element = '';
		
		// Do we have a element
		if (typeof element === 'undefined') {
			return false;
		}
		
		// Check now for IOS devices and support for poinyter-events in css3 (all IOS devices have support, but we check just in case) 
		if(SCS.mediaplayer.isIOS() && ('pointerEvents' in document.body.style)) {
			
			// If everything is ok, finally create overlay image element
			$play_button_element = $('<img/>', {
				'class':SCS.mediaplayer.MASTER_CLASS+'ios-play',
				src: SCS.mediaplayer.IMAGES+'center-play.png',
				alt:'Play'
			}).appendTo(element);
		}

		return $play_button_element;
	};
	
	/**
	 * Animate event for controls
	 * 
	 * @param player_element {object} Player element
	 * param clear {Boolean} If true the animate event will be stop
	 */
	SCS.mediaplayer.ieToggleControls  = function(player_element, clear) {

		// Reset animated padding if cursor were hover over video
		if (clear) {
			player_element.animate({'padding-bottom': 0}, 'slow');
		} else {
			player_element.animate({'padding-bottom': 37}, 'slow');
		}
	};
	
	
	/**
	 * Everything that is relevant to full screen is processed here
	 * 
	 * @param document_body {object} Body document object
	 * @param player_element {object} Player element
	 * @param static_image {object} Image parent element
	 * @param static_image_parent {object} Video intro image
	 * @param fullscreen_button {object} Full screen button
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 * @param controller {object} Control object for player controls 
	 */
	SCS.mediaplayer.fullScreen = function(document_body, player_element, static_image, static_image_parent, fullscreen_button, info, controller) {
		var $player_width = 0, $player_height = 0;
				
		// Do we have a full screen button
		if (typeof fullscreen_button === 'undefined') {
			fullscreen_button = $(SCS.mediaplayer.CONTROL_CLASS + 'fullscreen', player_element);
		}
		
		// Check if we are in full screen mode
		if(info.properties.fullScreen) {
			info.clear('fullScreen');
			fullscreen_button.toggleClass(SCS.mediaplayer.MASTER_CLASS + 'control-smallscreen');
			document_body.toggleClass(SCS.mediaplayer.MASTER_CLASS + 'document-body');
			
			// Reset video image style
			if (info.image.presence) {
				
				// Check if we are working with JW player
				if (player_element.hasClass('playerType-jw')) {
					static_image = info.image.jw_intro;
					static_image_parent = info.image.jw_intro_parent;
					static_image.removeAttr('style');
					static_image_parent.removeAttr('style');
				}
				
				static_image.css({
					'width': '',
					'height': ''
				}).removeClass(SCS.mediaplayer.MASTER_CLASS + 'intro-image-width ' + SCS.mediaplayer.MASTER_CLASS + 'intro-image-height');
				
				// Reset image parent line-height
				static_image_parent.css('line-height', info.image.parent_height);
			}
			
			// Recalculate controls position
			controller.recalc();
			
		} else if(!info.properties.fullScreen && !info.state.videoLoading) {
			info.set('fullScreen');
			fullscreen_button.toggleClass(SCS.mediaplayer.MASTER_CLASS + 'control-smallscreen');
			document_body.toggleClass(SCS.mediaplayer.MASTER_CLASS + 'document-body');
			
			// Calculate the image position as opposed to video player
			if (info.image.presence) {
				
				// Recalculate image size and position
				SCS.mediaplayer.resizeFullScreenImage(player_element, static_image, static_image_parent, info);
			}
			
			// Recalculate controls position
			controller.recalc();
		}
	};
	
	
	/**
	 * Resize and reposition video intro image
	 * 
	 * @param player_element {object} Player element
	 * @param static_image {object} Video intro image
	 * @param static_image_parent {object} Video intro image
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 */
	SCS.mediaplayer.resizeFullScreenImage = function(player_element, static_image, static_image_parent, info) {
		var player_element_height = player_element.height();
		
		// Check if we are working with JW player
		if (player_element.hasClass('playerType-jw')) {
			static_image = info.image.jw_intro;
			static_image_parent = info.image.jw_intro_parent;
			static_image.removeAttr('style');
			static_image_parent.removeAttr('style');
		}
		
		// Reset image height, width and remove previous full screen classes
		static_image.css({
			'width': '',
			'height': ''
		}).removeClass(SCS.mediaplayer.MASTER_CLASS + 'intro-image-width ' + SCS.mediaplayer.MASTER_CLASS + 'intro-image-height');
		
		// Check which side of image to resize
		if ((player_element.width() / static_image.width()) < (player_element_height / static_image.height())) {
			static_image.addClass(SCS.mediaplayer.MASTER_CLASS + 'intro-image-width');
		} else {
			static_image.addClass(SCS.mediaplayer.MASTER_CLASS + 'intro-image-height');
		}
		
		// Set new image parent line-height
		static_image_parent.css('line-height', (player_element_height - 2) + 'px');
	};
	
	
	/**
	 * Listen for screen resize event in full screen mode
	 * 
	 * @param player_element {object} Player element
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 * @param static_image {object} Video intro image
	 * @param static_image_parent {object} Video intro image
	 * @param controller {object} Control object for player controls
	 */
	SCS.mediaplayer.fullScreenResize = function(player_element, info, static_image, static_image_parent, controller) {
		$(w).resize(function() {
			SCS.mediaplayer.fullScreenResizeChain(player_element, info, static_image, static_image_parent, controller);
		});
	};
	
	
	/**
	 * Chain function for full screen resize event
	 * 
	 * @param player_element {object} Player element
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 * @param static_image {object} Video intro image
	 * @param static_image_parent {object} Video intro image
	 * @param controller {object} Control object for player controls
	 */
	SCS.mediaplayer.fullScreenResizeChain = function(player_element, info, static_image, static_image_parent, controller) {
		
		// Check if are in full screen mode
		if (player_element.hasClass('fullScreen')) {
			
			// Recalculate image size and position
			if (info.image.presence) {
				SCS.mediaplayer.resizeFullScreenImage(player_element, static_image, static_image_parent, info);
			}
			
			// Recalculate controls position
			if (!info.properties.noToolbar) {
				controller.recalc();
			}
		}
	};
	
	
	/**
	 * Checks if flash is installed/enabled on the browser
	 * 
	 * @return hasFlash {boolean} True or false for flash player
	 */
	SCS.mediaplayer.isFlashEnabled = function() {
		var hasFlash = false;

		try {
			var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
			if(fo) {
				hasFlash = true;
			}
		}

		catch(e) {
			if(navigator.mimeTypes["application/x-shockwave-flash"] !== undefined) {
				hasFlash = true;
			}
		}

		return hasFlash;
	};
	
	
	/**
	 * Main video controller
	 *
	 * @param controls {object} Children of scs-media-player-controls class
	 * @param callbacks {function} Player function in media player API
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 */
	SCS.mediaplayer.controller = function(controls, callbacks, info) {
		callbacks = callbacks || {};
		var $_this = this,
			$volume = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'volume-control'),
			$progress = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'progress'),
			$bar = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'bar-body'),
			$buttons = {},
			$quiet = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'volume-quiet'),
			$loud = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'volume-loud'),
			
			// Get button element
			$button = function(name) {
				
				if(!$buttons[name]) {
					$buttons[name] = $bar.find(SCS.mediaplayer.CONTROL_CLASS + ''+name);
				}
				
				return {
					click: function(callback) {
						$buttons[name].click(callback);
					}
				};
			};
			
		// Hidden overlay for IE browsers, they put flash always on top in any mode
		if (w.ActiveXObject !== undefined && info.properties.playerType === 'youTube') {
			$('<div/>', {
				'class': SCS.mediaplayer.MASTER_CLASS + 'ie-overlay'
			}).insertBefore(controls);
		}
		
		this.timeIndex = (function(){
			var progressMeter = $progress.find(SCS.mediaplayer.CONTROL_CLASS + 'progress-meter'),
				timeMeter = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'time'),
				total,
				percentage = 0,
				time = 0,
				previousTime;
	
			return {
				update: function(uiOnly, drag) {
					if(previousTime !== Math.floor(time)) {
						previousTime = Math.floor(time);
						var minutes = ''+Math.floor(time/60),
							seconds = ''+Math.floor(time%60);
							
						if(seconds.length < 2) {
							seconds = '0'+seconds;
						}
						
						timeMeter.text(''+minutes+':'+seconds);
						progressMeter.css('width', ''+percentage*100+'%');
						$_this.recalc(); //Recalc the bar’s dimensions because the time display might be larger
					}
					if(!uiOnly && callbacks.timeIndex) {
						callbacks.timeIndex(time);
					}
					return this;
				},
				
				setPercentage: function(percent) {
					if(total === undefined) {
						return this;
					}
					percentage = Math.min(Math.max(percent, 0), 100);
					time = Math.floor(total * percentage);
					return this;
				},
				
				setTime: function(timeIndex) {
					if(total === undefined) {
						return this;
					}
					time = timeIndex;
					percentage = time/total;
					return this;
				},
				
				setTotal: function(tot) {
					total = tot;
					return this;
				}
			};
		})();
				
		this.volume = (function() {
			var volumeMeter = $volume.find(SCS.mediaplayer.CONTROL_CLASS + 'volume-control-meter'),
				percentage = 1;
				
			return {
				update: function(drag) {
					volumeMeter.css('width', ''+(percentage*100)+'%');
					if(callbacks.volume) {
						callbacks.volume(percentage*100);
					}
					return this;
				},
				
				setPercentage: function(percent) {
					percentage = Math.min(Math.max(percent, 0), 100);
					return this.update();
				}
			};
		})();
	
		$progress.click(function(event) {
			var $x = event.pageX - $progress.offset().left + 2,
				$percentage = $x/$progress.width();
			$_this.timeIndex.setPercentage($percentage).update();
		});
		
		$volume.click(function(event) {
			var x = event.pageX - $volume.offset().left + 2,
				percentage = x/$volume.width();
			$_this.volume.setPercentage(percentage);
		});
		
		$button('volume-quiet').click(function() {
			$_this.volume.setPercentage(0);
			$(this).toggleClass(SCS.mediaplayer.MUTE_CLASS);
		});
		
		$button('volume-loud').click(function() {
			$_this.volume.setPercentage(1);
			if ($quiet.hasClass(SCS.mediaplayer.MUTE_CLASS)) {
				$quiet.removeClass(SCS.mediaplayer.MUTE_CLASS);
			}
		});
		
		$button('playpause').click(function() {
			if(callbacks.playPause) {
				callbacks.playPause();
			}
		});
		
		$button('fullscreen').click(function() {
			if(callbacks.fillScreen) {
				callbacks.fillScreen();
			}
		});
		
		var center_controls = controls.find(SCS.mediaplayer.CONTROL_CLASS + 'center').click(function() {
			if(info.state.finished) {
				return callbacks.restart && callbacks.restart();
			} else if(!info.state.videoLoading && callbacks.playPause) {
				callbacks.playPause();
			}
		});
		
		var $bar_holder = $bar.parent();
		
		this.recalc = function(barOnly) {
			controls.css('display', 'block');
			$bar_holder.css('display', 'block');
			
			if(!barOnly) {
				var playerHeight = (controls.parent().height() < parseInt(controls.parent().css('height'), 10)) ? parseInt(controls.parent().css('height'), 10) : controls.parent().height();
				controls.find(SCS.mediaplayer.CONTROL_CLASS + 'center').css('top', ''+(playerHeight/2)+'px');
			}
			
			var $bar_width = $bar.width(),
				$other_items = 0;
			
			$bar.children().each(function() {
				var element = $(this);
				if(this !== $progress[0]) {
					$other_items += element.outerWidth(true);
				} else {
					$other_items += parseInt(element.css('margin-left'), 10) + parseInt(element.css('margin-right'), 10) + parseInt(element.css('padding-left'), 10) + parseInt(element.css('padding-right'), 10);
				}
			});
			
			$bar_holder.css('display', '');
			controls.css('display', '');
			$progress.width($bar_width - $other_items - 5);
		};
		
		this.timeIndex.update(true);
		this.volume.update();
		
		/* Lets make things a little bit more interesting for the visitors
		 * If the UI is present in the document, they will be able to scroll video and change volume using mouse drag
		 * TO DO - This can be achieve also with pure jQuery 
		 */
		if (typeof $.ui.draggable == 'function') {
			var percentageUpdate = 0;
			
			// Video control
			$(SCS.mediaplayer.CONTROL_CLASS + 'progress-indicator', controls).draggable({
				axis: 'x',
				containment: $progress,
				drag: function() {
					percentageUpdate = $(this).position().left / $progress.width();
					if (percentageUpdate <= 0) {
						percentageUpdate = -0.014;
					}
					
					$_this.timeIndex.setPercentage(percentageUpdate + 0.015).update();
				},
				stop: function() {
					$(this).css('left', '');
				}
			});
			
			// Volume control
			$('.progress-indicator', $volume).draggable({
				axis: 'x',
				containment: $volume,
				drag: function() {
					percentageUpdate = $(this).position().left / $volume.width();
					if (percentageUpdate <= 0) {
						percentageUpdate = -0.16;
						$quiet.addClass(SCS.mediaplayer.MUTE_CLASS);
					} else {
						$quiet.removeClass(SCS.mediaplayer.MUTE_CLASS);
					}
					
					$_this.volume.setPercentage(percentageUpdate + 0.17).update();
				},
				stop: function() {
					$(this).css('left', '');
				}
			});
		}
	};
	
	
	/**
	 * Youtube player
	 *
	 * @param element {object} Player video container with intro image
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 * @param id {string} YouTube video ID
	 * @param static_image {object} Video intro image
	 * 
	 * @return $callbacks {object} Control player object with playPause, volume, timeIndex and restart functions
	 */
	SCS.mediaplayer.youTube = function(element, info, id, static_image) {
		
		var $player_element = element.parent(),
			$youtubePlaceholder = $('.scs-youtubePlaceholder', element),
			$staticImage_parent = static_image.parent(),
			$staticImageIframe = '',
			$play_button = SCS.mediaplayer.playOverlay($player_element),
			fun;
			
		// We manage the static image ourselves since there is no option for it
		if(!$staticImage_parent.length) {
			$staticImage = null;
			element.addClass('yt-no-staticImage');
		}
		
		// Time update functions
		var $player,
			$updater = (function() {
			var $timeIndexInterval = null,
				$updater = function() {
				info.updateTime($player.getCurrentTime(), $player.getDuration());
			};
			return {
				set: function() {
					this.clear();
					$timeIndexInterval = w.setInterval($updater, 1000);
					$updater();
				},
				clear: function() {
					if ($timeIndexInterval) {
						w.clearInterval($timeIndexInterval);
						$timeIndexInterval = null;
					}
				}
			};
		})();
		
		var $load = function() {
			
			$player = new YT.Player($youtubePlaceholder[0], {
				
				// Player vars
				height: '100%',
				width: '100%',
				videoId: id,

				playerVars: {
					autoplay: 0,
					controls: SCS.mediaplayer.isIOS(),
					enablejsapi: 1,
					modestbranding: 1,
					showinfo: 0,
					rel: 0,
					iv_load_policy: 3,
					wmode: 'transparent',
					origin: encodeURIComponent(w.location.protocol + '//' + w.location.host)
				},
				
				// Events
				events: {
					onReady: function() {
						w.player = $player;
						info.set('pausing');
						if(info.properties.autoPlay) {
							$player.playVideo();
						}
					},
					
					// State of video
					onStateChange: function(state) {
						
						switch(state.data) {
							
							// Paused
							case YT.PlayerState.PAUSED:
								$updater.clear();
								info.set('pausing');
								break;
							
							// Playing
							case YT.PlayerState.PLAYING:
								$updater.set();
								info.set('playing');
								
								$staticImage_parent.hide();

								if ($play_button) {
									$staticImage_parent.hide();
								}
								
								break;
								
							// Ended
							case YT.PlayerState.ENDED:
								$updater.clear();
								info.set('finished');
								
								if ($staticImage_parent) {
									if (!$player_element.hasClass('fullScreen')) {
										static_image.css('margin-top', info.image_top_margin);
									}
									
									$staticImage_parent.show();
								}
								
								if ($play_button) {
									$play_button.attr('src', SCS.mediaplayer.IMAGES + 'center-restart.png').show();
								}
								
								break;
							
							// Buffering
							case YT.PlayerState.BUFFERING:
								$updater.clear();
								info.set('videoLoading');
								
								if ($play_button) {
									$play_button.attr('src', SCS.mediaplayer.IMAGES + 'center-loading.gif').show();
								}
								
								break;
								
						} // Switch
					} // Status change
				} // Events
			}); // YT player
			
			// Since we are replacing placeholder we need to get new iframe element of player
			$youtubePlaceholder = $('.scs-youtubePlaceholder', element);
		}; // Load

		// Check for YouTube script and player function
		if(w.YT && YT.Player) {
			$load();
		} else {
			if(typeof w.onYouTubePlayerAPIReady != 'function') {
			
				w.onYouTubePlayerAPIReady = function() {
					$.each(arguments.callee.loaders, function(index, loader) { loader(); });
				};
				
				w.onYouTubePlayerAPIReady.loaders = [];
				var tag = document.createElement('script');
				tag.src = '//www.youtube.com/player_api';
				var firstScriptTag = document.getElementsByTagName('script')[0];
				firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
				
			}
			w.onYouTubePlayerAPIReady.loaders.push($load);
		}

		// Player functions callbacks
		var $callbacks = {
			playPause: function(mode) {
				if(mode === undefined) {
					mode = $player.getPlayerState();
					mode = (mode === undefined || mode === YT.PlayerState.PAUSED || mode === YT.PlayerState.ENDED || mode === -1 || mode === YT.PlayerState.CUED);
				}
				if(mode) {
					$player.playVideo();
				} else {
					$player.pauseVideo();
				}
				return this;
			},
			volume: function(volume) {
				$player.setVolume(volume);
				return this;
			},
			timeIndex: function(index) {
				$player.seekTo(index, true);
				return this;
			},
			restart: function() {
				$player.seekTo(0, true);
				$player.playVideo();
				return this;
			}
		};
		
		var $fun_callback_function = function(orig, fun) {
			$callbacks[fun] = function() {
					
				// Discard calls made before the player was ready
				if(!$player || !$player.playVideo) {
					return this;
				}
				return orig.apply(this, [].slice.call(arguments));
			};
		};
		
		for(fun in $callbacks) {
			if($callbacks.hasOwnProperty(fun)) {
				$fun_callback_function($callbacks[fun], fun);
			}
		}
		
		return $callbacks;
	};

	
	/**
	 * JW player
	 *
	 * @param element {object} Player video container with intro image
	 * @param info {object} Info object with properties and state object and with clear, set and update function
	 * @param url {string} Video URL
	 * @param static_image {object} Video intro image
	 * @param url {string} Video format
	 * 
	 * @return {object} Control player object with playPause, volume, timeIndex and restart functions
	 */
	SCS.mediaplayer.jw = function(element, info, url, static_image, format) {
		
		var levels = [],
			$playerId = element.attr('id'),
			$player = jwplayer($playerId), // This is stupid: why not be able to just pass the element? I guess LongTail have their reasons!
			$player_parent_element = element.parent(),
			$play_button = SCS.mediaplayer.playOverlay(element.parent()),
			$player_render_mode, $html5_video_element;
		
		// Lets create array for player
		levels.push({file: url, type: SCS.mediaplayer.mimeType(format)});
		
		// Because JW player limit child elements to parent size we need to over ride that (only for non IOS devices)
		if ($play_button) {
			$player_parent_element.addClass('jw-ios');
		} else {
			$player_parent_element.addClass('jw-fullscreen');
		}
		
		// Start JW player
		$player.setup({
			'id': $playerId,
			'controlbar.position': 'none',
			icons: false,
			image: static_image.attr('src'),
			'tracker.movie_id': $player_parent_element.data('tracker-movie-id'),
			'tracker.report_suite': $player_parent_element.data('tracker-reportsuite'),
			'tracker.catalogue': $player_parent_element.data('tracker-catalogue'),
			'tracker.category': $player_parent_element.data('tracker-category'),
			levels: levels,
			'plugins': '/etc/designs/portal/resources/player/plugins/Tracker.swf',
			
			modes: [
				{ type: 'html5' }
			],
			
			events: {
				onReady: function() {
					info.set('pausing');
					$html5_video_element = $('video', $player.container);
					$player_render_mode = $player.getRenderingMode();
					
					if(info.properties.autoPlay) {
						$player.play(true);
					}
					
					if (info.image.presence) {
						info.image.jw_intro_parent = $('div[id^=scs-media-player-scs-video][id$=_jwplayer_display]', $player.container);
						info.image.jw_intro = $('> img', info.image.jw_intro_parent);
						info.image.jw_intro_parent.removeAttr('style');
						info.image.jw_intro.removeAttr('style');
						info.image.jw_intro_parent.css('line-height', info.image.parent_height);
					} else if ($player_render_mode === 'html5' && !$html5_video_element.attr('src')) {
						
						// We are manually inserting video url in video element, 
						// because JW player remove it at the start and end of video?
						$html5_video_element.attr('src', url);
					}
					
					if ($play_button) {
						$player.playButtonSrc = $play_button.attr('src');
						$player.jwElementParent = $('#' + $playerId).parent();
					}
				},
				
				onPlay: function() {
					info.set('playing');
					if ($play_button) {
						$play_button.hide();
						$player.jwElementParent.removeClass('jw-ios');
					}
					
					if (info.image.presence) {
						info.image.jw_intro.attr('style', 'display: none !important;');
					}
				},
				
				onPause: function() {
					info.set('pausing');
					if ($play_button && $player.playButtonSrc) {
						$play_button.attr('src', $player.playButtonSrc).show();
					}
					
					if (info.image.presence) {
						info.image.jw_intro.attr('style', 'display: none !important;');
					}
				},
				
				onBuffer: function() {
					info.set('videoLoading');
					if ($play_button) {
						$play_button.attr('src', SCS.mediaplayer.IMAGES + 'center-loading.gif').show();
						$player.jwElementParent.removeClass('jw-ios');
					}
					
					if (info.image.presence) {
						info.image.jw_intro.attr('style', 'display: none !important;');
					}
				},
				
				onComplete: function() {
					info.set('finished');
					if ($play_button) {
						$play_button.attr('src', SCS.mediaplayer.IMAGES + 'center-restart.png').show();
					}
					
					if (info.image.presence) {
						info.image.jw_intro.removeAttr('style');
					}
					
					if ($player_render_mode === 'html5') {
					
						// Stupid, stupid, stupid, the JW remove source attribute 
						// from video after all events, hence show empty black screen!
						setTimeout(function() {
							if (!$html5_video_element.attr('src')) {
								$html5_video_element.attr('src', url);
							}
						}, 50);
					}
				},
				
				onTime: function(e) {
					info.updateTime(e.position, e.duration);
				}
			},
			
			width: '100%',
			height: '100%',
			volume: 100
		});
		
		return {
			playPause: function(mode) {
				$player.play(mode);
				return this;
			},
			volume: function(volume) {
				$player.setVolume(volume);
				return this;
			},
			timeIndex: function(index) {
				$player.seek(index);
				return this;
			},
			restart: function() {
				$player.seek(0);
				$player.play(true);
				return this;
			}
		};
	};
	
	
	/**
	 * Check input format and return corresponding mime type
	 *
	 * @param format {string} Video format
	 * 
	 * @return {string} Mime type of input string
	 */
	SCS.mediaplayer.mimeType = function(format) {
		var $mime_type;
		
		switch (format) {
			case 'mp4':
				$mime_type = 'video/mp4';
				break;
			case 'webm': 
				$mime_type = 'video/webm';
				break;
			case 'ogg':
			case 'ogv':
				$mime_type = 'video/ogg';
				break;
			case 'flv':
				$mime_type = 'video/x-flv';
				break;
			default: 
				$mime_type = false;
				break;
		}
		
		return $mime_type;
	};
	
	
	/**
	 * Media player API
	 * Extend jQuery in form of a plugin
	 * 
	 * @return player_element.data {object} Main media player object
	 */
	$.fn.mediaPlayer = function() {
		if(!this.length) {
			return null;
		}
		
		// Set vars for player
		var $document_body = $('body'),
			$player_element = this.eq(0),
			$autoPlay = $player_element.data('autoplay') === 'true',
			$static_image = $('img:first', $player_element),
			$static_image_parent,
			$staticImage_src = $static_image.attr('src'),
			$overlay = $player_element.children('.scs-media-player-controls'),
			$noFlashOverlay = $player_element.children('.' + SCS.mediaplayer.MASTER_CLASS + 'no-flash'),
			$noFlashSwfContainer = $noFlashOverlay.children('.' + SCS.mediaplayer.MASTER_CLASS + 'no-flash-swf-container'),
			$format = $player_element.attr('data-video-type'),
			$playerType = ($format === 'youtube' ? 'youTube' : 'jw'),
			$player = SCS.mediaplayer[$playerType],
			$controller, $callbacks;
		
		if($player_element.data('mediaPlayer')) {
			return $player_element.data('mediaPlayer');
		}
		
		var info = (function() {
			var properties = {fullScreen: false, noToolbar: false, autoPlay: $autoPlay, playerType: $playerType},
				state = {playing: false, videoLoading: false, finished: false, pausing: false},
				image = {presence: false},
				
				controls = {
					set: function(stateName, value) {
						value = value || true;
						var name;
						if(state[stateName] === undefined) {
							properties[stateName] = value;
						} else {
							for(name in state) {
								if(state.hasOwnProperty(name)) {
									state[name] = false;
									$player_element.removeClass(name);
								}
							}
							state[stateName] = value;
						}
						$player_element.addClass(stateName);
						return this;
					},
					
					clear: function(stateName) {
						if(state[stateName] === undefined) {
							properties[stateName] = false;
						} else {
							state[stateName] = false;
						}
						$player_element.removeClass(stateName);
						return this;
					},
					
					properties: properties,
					state: state,
					image: image
				};
			
			controls.set('videoLoading');
			return controls;
		})();
		
		// Set static images
		if ($static_image.length) {
			$static_image_parent = $static_image.parent();
			$static_image_parent_height = ($player_element.height() - 2) + 'px';
			
			// We are adding line-height in order to position image vertically middle
			$static_image_parent.css({
				'line-height': $static_image_parent_height
			});
			
			// Set image properties
			info.image.presence = true;
			info.image.parent_height = $static_image_parent_height;
		}

		// Initialize the player
		$player_element.addClass('playerType-' + $playerType);
		$callbacks = $player($player_element.children('.scs-media-player-content'), info, $player_element.data('video-url'), $static_image, $format);

		// Controller
		if (!SCS.mediaplayer.isFlashEnabled() && navigator.userAgent.toLowerCase().indexOf('firefox') != -1) {
			$overlay.remove();
			$noFlashOverlay.show();
			$noFlashSwfContainer.html('<object height="0" width="0"><embed src="/etc/designs/portal/resources/player/so_redirect.swf" type="application/x-shockwave-flash" height="0" width="0"/></object>');
			info.set('noToolbar');
		} else if('ontouchstart' in w) {
			$overlay.remove();
			info.set('noToolbar');
		} else {
			$controller = new SCS.mediaplayer.controller($overlay, $callbacks, info);
		}
				
		// Check for window resize in full screen mode
		SCS.mediaplayer.fullScreenResize($player_element, info, $static_image, $static_image_parent, $controller);
		
		// Update play time
		info.updateTime = function(current, total) {
			if (!info.properties.noToolbar) {
				$controller.timeIndex.setTotal(total).setTime(current).update(true);
			}
		};
		
		// Full screen
		$callbacks.fillScreen = function(fullscreen_button) {
			
			// Process full screen event
			if (!info.properties.noToolbar) {
				SCS.mediaplayer.fullScreen($document_body, $player_element, $static_image, $static_image_parent, fullscreen_button, info, $controller);
			}
			
			return this;
		};
		
		// Bind some key events for current document
		$(document).on('keydown', function(event) {
			if(info.properties.fullScreen) {
				if(event.keyCode === 32) {
					$callbacks.playPause();
					return false;
				} else if (event.keyCode === 27) {
					$callbacks.fillScreen();
					return false;
				}
			}
		});

		// Set player data
		$player_element.data('mediaPlayer', {callbacks: $callbacks, controller: $controller, info: info});
		return $player_element.data('mediaPlayer');
	};
})(jQuery, window);



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/mediaplayer.js
// module id = 109
// module chunks = 0